import _ from 'lodash';
import { getUpdatedFormatConfig, } from '../../client-state-type';
import { AnswerColumnPropVersion, } from '../../types/prism';
import { AnswerColumnPropV1Class } from '../types/v1';
const upgradeV0toV1 = (inputClientState, answerColumnModel) => {
    const { answerSheetClientState, columnId, legacyColumnFormatProperties, } = answerColumnModel;
    let columnProperties = null;
    if (answerSheetClientState &&
        answerSheetClientState.columnProperties &&
        answerSheetClientState.columnProperties[columnId]) {
        columnProperties = {
            __typename: 'AnswerColumnProperty',
            format: getUpdatedFormatConfig(answerSheetClientState.columnProperties[columnId].format),
            sortConfig: null,
        };
    }
    else if (!_.isEmpty(legacyColumnFormatProperties)) {
        columnProperties = {
            __typename: 'AnswerColumnProperty',
            format: getUpdatedFormatConfig(legacyColumnFormatProperties),
            sortConfig: null,
        };
    }
    const clientState = {
        __typename: 'AnswerColumnProps',
        version: AnswerColumnPropVersion.V1,
        columnProperties,
    };
    const upgradedClientState = new AnswerColumnPropV1Class();
    _.assign(upgradedClientState, clientState);
    return upgradedClientState;
};
const upgraderFn = (clientState, answerColumnModel) => {
    return upgradeV0toV1(clientState, answerColumnModel);
};
export { upgraderFn };
//# sourceMappingURL=v0-to-v1.js.map